import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { maxLength } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

const fieldValidator = {
  //owner: [value => maxLength(value, 255)],
  owner_first_name: [value => maxLength(value, 255)],
  owner_last_name: [value => maxLength(value, 255)],

  //second_owner: [value => maxLength(value, 255)],
  second_owner_first_name: [value => maxLength(value, 255)],
  second_owner_last_name: [value => maxLength(value, 255)],

  //third_owner: [value => maxLength(value, 255)],
  third_owner_first_name: [value => maxLength(value, 255)],
  third_owner_last_name: [value => maxLength(value, 255)],

  //fourth_owner: [value => maxLength(value, 255)],
  fourth_owner_first_name: [value => maxLength(value, 255)],
  fourth_owner_last_name: [value => maxLength(value, 255)],

  vesting_1: [value => maxLength(value, 255)],
  vesting_2: [value => maxLength(value, 255)]
};
class HomeownersModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: props.entity[key] !== null ? props.entity[key] : '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.props.onSubmit(postData, null);
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Edit Homeowners'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              {this.props.errorUnit && (
                <Alert color={'danger'}>{this.props.errorUnit}</Alert>
              )}
              <Row>
                <Col xs={3}>
                  <LabelInput
                    name={'Owner'}
                    type={'text'}
                    placeholder={'First Name'}
                    {...this.state.owner_first_name}
                    onChange={event =>
                      this.updateForm(event, 'owner_first_name')
                    }
                  />
                </Col>
                <Col xs={3}>
                  <LabelInput
                    name={' '}
                    type={'text'}
                    placeholder={'Last Name'}
                    {...this.state.owner_last_name}
                    onChange={event =>
                      this.updateForm(event, 'owner_last_name')
                    }
                  />
                </Col>
                <Col xs={3}>
                  <LabelInput
                    name={'2nd Owner'}
                    type={'text'}
                    placeholder={'First Name'}
                    {...this.state.second_owner_first_name}
                    onChange={event =>
                      this.updateForm(event, 'second_owner_first_name')
                    }
                  />
                </Col>
                <Col xs={3}>
                  <LabelInput
                    name={' '}
                    type={'text'}
                    placeholder={'Last Name'}
                    {...this.state.second_owner_last_name}
                    onChange={event =>
                      this.updateForm(event, 'second_owner_last_name')
                    }
                  />
                </Col>
              </Row>
              <Row className={'mb-3'}>
                <Col>
                  <LabelInput
                    name={'Vesting'}
                    type={'text'}
                    {...this.state.vesting_1}
                    onChange={event => this.updateForm(event, 'vesting_1')}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={3}>
                  <LabelInput
                    name={'3rd Owner'}
                    type={'text'}
                    placeholder={'First Name'}
                    {...this.state.third_owner_first_name}
                    onChange={event =>
                      this.updateForm(event, 'third_owner_first_name')
                    }
                  />
                </Col>
                <Col xs={3}>
                  <LabelInput
                    name={' '}
                    type={'text'}
                    placeholder={'Last Name'}
                    {...this.state.third_owner_last_name}
                    onChange={event =>
                      this.updateForm(event, 'third_owner_last_name')
                    }
                  />
                </Col>
                <Col xs={3}>
                  <LabelInput
                    name={'4nd Owner'}
                    type={'text'}
                    placeholder={'First Name'}
                    {...this.state.fourth_owner_first_name}
                    onChange={event =>
                      this.updateForm(event, 'fourth_owner_first_name')
                    }
                  />
                </Col>
                <Col xs={3}>
                  <LabelInput
                    name={' '}
                    type={'text'}
                    placeholder={'Last Name'}
                    {...this.state.fourth_owner_last_name}
                    onChange={event =>
                      this.updateForm(event, 'fourth_owner_last_name')
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'Vesting2'}
                    type={'text'}
                    {...this.state.vesting_2}
                    onChange={event => this.updateForm(event, 'vesting_2')}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default HomeownersModal;
